import { UserTypeEnum, UserTypeLabelEnum } from '../../../interfaces/user.interface';

interface UserTypeSelectorProps {
  handleSelectedUserType: (userType: UserTypeEnum) => void;
}

const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({
                                                             handleSelectedUserType
                                                           }: UserTypeSelectorProps) => {
  return (
    <div className="flex items-center">
      <label htmlFor="plans" className="text-sm sm:text-base mr-2">
        Select User Type:
      </label>
      <select
        id="plans"
        className="p-2 border rounded-md text-sm sm:text-base"
        onChange={(e) => {
          const userType = e.target.value;
          handleSelectedUserType(userType as UserTypeEnum);
        }}
      >
        <option value="" disabled selected>
          Select a user type
        </option>
        {Object.keys(UserTypeEnum).map((key) => (
          <option key={key} value={UserTypeEnum[key as keyof typeof UserTypeEnum]}>
            {UserTypeLabelEnum[UserTypeEnum[key as keyof typeof UserTypeEnum]]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default UserTypeSelector;
